export const cilDoubleQuoteSansRight = ["24 24","<path d='M21.45 0.75l-8.325 7.929v10.821h10.125v-18.75zM21.75 18h-7.125v-8.679l7.125-6.786z'></path><path d='M0.75 8.679v10.821h10.125v-18.75h-1.8zM9.375 18h-7.125v-8.679l7.125-6.786z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-double-quote-sans-right.js
// module id = null
// module chunks = 